export const useToggleEnvironment = () => {
  const getModeStatus = () => {
    return localStorage.getItem('isTesting')
  }

  const toggleModeStatus = () => {
    const current = getModeStatus()

    if (!current || current === 'OFF') {
      localStorage.setItem('isTesting', 'ON')
    } else {
      localStorage.setItem('isTesting', 'OFF')
    }

    return getModeStatus()
  }

  const dispatchEventStorage = ({ key, newValue }) => {
    window.dispatchEvent(new StorageEvent('storage', { key, newValue }))
  }

  return {
    toggleModeStatus,
    getModeStatus,
    dispatchEventStorage,
  }
}
